const env = "f26a8f7469fe35d16085c6e4d046fb36";

export default env;